var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',_vm._l((_vm.item_keys),function(item_key,index){return _c('td',{key:(item_key + "-" + index),class:_vm.getColClassesForIndex(index)},[_c('table-cell-component',{attrs:{"bus":_vm.bus,"cell_item":_vm.getItemForKey(item_key)}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }